export default __webpack_public_path__ + "4c8ed0279e176339ff89091d43b50226.svg";